(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-rsi-quote-scroll]');
    if (!trigger) return;

    var targetId = trigger.getAttribute('href');
    if (!targetId || targetId.charAt(0) !== '#') return;

    var target = document.querySelector(targetId);
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
      block: 'start'
    });

    window.setTimeout(function () {
      if (typeof target.focus === 'function') {
        target.focus({ preventScroll: true });
      }
    }, prefersReducedMotion ? 0 : 350);
  });
})();
